import { render, staticRenderFns } from "./TimeWidget.vue?vue&type=template&id=3af0ef5f&scoped=true"
import script from "./TimeWidget.vue?vue&type=script&lang=js"
export * from "./TimeWidget.vue?vue&type=script&lang=js"
import style0 from "./TimeWidget.vue?vue&type=style&index=0&id=3af0ef5f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af0ef5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af0ef5f')) {
      api.createRecord('3af0ef5f', component.options)
    } else {
      api.reload('3af0ef5f', component.options)
    }
    module.hot.accept("./TimeWidget.vue?vue&type=template&id=3af0ef5f&scoped=true", function () {
      api.rerender('3af0ef5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/TimeWidget.vue"
export default component.exports